document.addEventListener("DOMContentLoaded", () => {
	// check browser version

		navigator.sayswho= (function(){
			var ua= navigator.userAgent;
			var tem;
			var M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
			if(/trident/i.test(M[1])){
				tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
				return 'IE '+(tem[1] || '');
			}
			if(M[1]=== 'Chrome'){
				tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
				if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
			}
			M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
			if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
			return M.join(' ');
		})();

	if (!customElements.get('localization-form')) {
		class LocalizationForm extends HTMLElement {
			constructor() {
				super();
				this.elements = {
						input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
						button: this.querySelector('.disclosure__button'),
						panel: this.querySelector('ul'),
						backButton: this.querySelector('.curr-back')
					};

				this.hasClicked = false;

				this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
				this.addEventListener('focusout', this.closeSelector.bind(this));
				this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

				if (this.elements.backButton) {
					this.elements.backButton.addEventListener('click', this.hidePanel.bind(this));
				}

				this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
				// this.querySelectorAll('a').forEach(item => item.addEventListener('touchstart', this.onItemClick.bind(this)));
			}
			hidePanel() {
				this.hasClicked = false
				this.elements.button.setAttribute('open', 'false');
				this.elements.button.setAttribute('aria-expanded', 'false');
				this.elements.panel.setAttribute('hidden', true);
				this.elements.panel.classList.add('hidden');
				this.elements.panel.classList.remove('flex');
			}

			onContainerKeyUp(event) {
				if (event.code.toUpperCase() !== 'ESCAPE') return;

				this.hidePanel();
				this.elements.button.focus();
			}

			onItemClick(event) {
				event.preventDefault();

				const form = this.querySelector('form');

				this.elements.input.value = event.currentTarget.dataset.value;

				if (form) form.submit();
			}

			toggleSelector() {
				if(this.hasClicked) {
					this.hasClicked = false;
					return;
				}

				if(this.elements.button.getAttribute('open') === 'true') {
					this.hidePanel();
				} else {
					this.elements.button.setAttribute('open', 'true');
					this.elements.button.focus();
					this.elements.panel.classList.remove('hidden');
					this.elements.panel.classList.add('flex');
					this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
				}

			}

			closeSelector(event) {
				this.hasClicked = true
				let shouldClose = !(event.relatedTarget?.matches('a') || event.relatedTarget?.matches('li'))
				if(navigator.sayswho.indexOf('Safari') >= 0 ){
					onItemClick(event)
				}
				if (shouldClose || (event.relatedTarget === null && shouldClose ) ) {
					this.hidePanel();
				}
				setTimeout(() => this.hasClicked = false, 500);
			}
		}
		customElements.define('localization-form', LocalizationForm);
	}
});
